import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import signout from "../assests/images/navSignOut.svg";
import dashboard from "../assests/images/navDashboard.svg";
import { useAuth } from "../api/authUtils/AuthContext";
import ErrorPopUp from "../components/utilities/ErrorPopUp";
import { logoutUser } from "../api/authUtils/helper/auth";
import { useNavigate } from "react-router-dom";
import { ReactComponent as TokenIcon } from "../assests/images/token.svg";
import { ReactComponent as AgreementIcon } from "../assests/images/agreement.svg";
import { ReactComponent as UserIcon } from "../assests/images/user.svg";
import { ReactComponent as OrgIcon } from "../assests/images/org.svg";
import { ReactComponent as JobIcon } from "../assests/images/job.svg";
import { ReactComponent as RunsIcon } from "../assests/images/runs.svg";
import { ReactComponent as AuditIcon } from "../assests/images/audit.svg";
import { ReactComponent as DockerIcon } from "../assests/images/docker.svg";
export default function AdminNavbarMenu() {
  const location = useLocation();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const handleLogout = async () => {
    const success = await logoutUser();
    if (success) {
      setUser(null); // clear user context
      navigate("/login", {
        state: { message: "Logged out successfully." },
      }); // redirect to login
    } else {
      setError("User Logout Unsuccessful");
    }
  };
  return (
    <>
      {error && (
        <ErrorPopUp
          show={true}
          onClose={() => setError(null)}
          heading="Logout Error"
          text={error}
        />
      )}

      <div className="navbar-menu-wrapper">
        <div className="navbar-menu">
          <div style={{ paddingBottom: "16px" }}>
            <p className=" navbar-heading text-white">Admin Menu</p>

            <ul className="nav flex-column mb-auto nav-pills">
              <li>
                <Link
                  to="/admin_dashboard"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/admin_dashboard" ? "active-custom" : ""
                  }`}
                >
                  <UserIcon
                    className={`me-2 ${
                      location.pathname === "/admin_dashboard" ? "text-dark" : ""
                    }`}
                    height={16}
                  />
                  Users
                </Link>
              </li>

              <li>
                <Link
                  to="/admin_dashboard/orgs"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/admin_dashboard/orgs" ? "active-custom" : ""
                  }`}
                >
                  <OrgIcon
                    className={`me-2 ${
                      location.pathname === "/admin_dashboard/orgs" ? "text-dark" : ""
                    }`}
                    height={16}
                  />
                  Organizations
                </Link>
              </li>

              <li>
                <Link
                  to="/admin_dashboard/tokens"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/admin_dashboard/tokens" ? "active-custom" : ""
                  }`}
                >
                  <TokenIcon
                    className={`me-2 ${
                      location.pathname === "/admin_dashboard/tokens" ? "text-dark" : ""
                    }`}
                    height={16}
                  />
                  Tokens
                </Link>
              </li>
              <li>
                <Link
                  to="/admin_dashboard/runs"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/admin_dashboard/runs" ? "active-custom" : ""
                  }`}
                >
                  <RunsIcon
                    className={`me-2 ${
                      location.pathname === "/admin_dashboard/runs" ? "text-dark" : ""
                    }`}
                    height={16}
                  />
                  Runs
                </Link>
              </li>

              <li>
                <Link
                  to="/admin_dashboard/audit"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/admin_dashboard/audit" ? "active-custom" : ""
                  }`}
                >
                  <AuditIcon
                    className={`me-2 ${
                      location.pathname === "/admin_dashboard/audit" ? "text-dark" : ""
                    }`}
                    height={16}
                  />
                  Audit
                </Link>
              </li>
              <li>
                <Link
                  to="/admin_dashboard/jobs"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/admin_dashboard/jobs" ? "active-custom" : ""
                  }`}
                >
                  <JobIcon
                    className={`me-2 ${
                      location.pathname === "/admin_dashboard/jobs" ? "text-dark" : ""
                    }`}
                    height={16}
                  />
                  Jobs
                </Link>
              </li>
              <li>
                <Link
                  to="/admin_dashboard/agreements"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/admin_dashboard/agreements"
                      ? "active-custom"
                      : ""
                  }`}
                >
                  <AgreementIcon
                    className={`me-2 ${
                      location.pathname === "/admin_dashboard/agreements"
                        ? "text-dark"
                        : ""
                    }`}
                    height={16}
                  />
                  Agreements
                </Link>
              </li>

              <li>
                <Link
                  to="/admin_dashboard/docker"
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === "/admin_dashboard/docker" ? "active-custom" : ""
                  }`}
                >
                  <DockerIcon
                    className={`me-2 ${
                      location.pathname === "/admin_dashboard/docker" ? "text-dark" : ""
                    }`}
                    height={16}
                  />
                  Docker
                </Link>
              </li>
            </ul>
          </div>

          <div className="mt-auto">
            <ul
              className="nav nav-pills flex-column mb-auto"
              style={{
                borderTop: "1px solid #434343",
                borderBottom: "1px solid #434343",
                padding: "10px 0",
              }}
            >
              <li>
                <Link
                  to="/dashboard"
                  className={`nav-link text-white d-flex align-items-center`}
                >
                  <img src={dashboard} alt="" />
                  User Dashboard
                </Link>
              </li>
              <li
                onClick={handleLogout}
              >
                <Link
                  to="#"
                  className={`nav-link text-white d-flex align-items-center `}
                >
                  <img src={signout} alt="" />
                  Sign Out
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
